import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsStructure({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6.5 10.7c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h5zm8 0c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h5zM8 5.75c.41 0 .75.34.75.75v.75H15c.38 0 .7.28.74.65l.01.1c0 .41-.34.75-.75.75h-2.25v.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75v-.75h-6.5v.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75v-.75H1a.75.75 0 01-.74-.65L.25 8c0-.41.34-.75.75-.75h6.25V6.5c0-.38.28-.7.65-.74zm2.5-4.45c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5h5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsStructure.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsStructure.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsStructure svgRef={ref} {...props} />
));
export default ForwardRef;
